import { createUnleash } from 'shared/unleash/hook';

export interface UnleashToggles {
    hotjar: boolean;
    numPax: boolean;
    topBarFilterUpdate: boolean;
}

const { UnleashProvider, useUnleash } = createUnleash<UnleashToggles>();

export { UnleashProvider, useUnleash };
